export default "__VITE_ASSET__CLTbnjN3__"